module.exports = __webpack_public_path__ + "static/media/faqImg1440.3d098e8c.jpeg";